export default __webpack_public_path__ + "static/media/checkmark.028d0b41.svg";